import React, { useState, useEffect } from 'react';
import { ec2Get } from '../utils/ec2api';
import './Promos.css';

export default function Promos() {
  const [promos, setPromos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    ec2Get('/promos')
      .then(setPromos)
      .catch(() => setPromos([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="promos-page"><div className="promos-empty">Cargando...</div></div>;

  return (
    <div className="promos-page">
      <div className="promos-hero">
        <h1>🎬 Promociones</h1>
        <p>Las mejores ofertas y novedades para ti</p>
      </div>

      {promos.length === 0 ? (
        <div className="promos-empty">No hay promociones activas por ahora</div>
      ) : (
        promos.map((p) => (
          <div className="promo-card" key={p.id}>
            {p.media_type === 'video' ? (
              <video className="promo-media" src={p.media_url} controls playsInline muted />
            ) : (
              <img className="promo-media" src={p.media_url} alt={p.titulo} />
            )}
            <div className="promo-body">
              <p className="promo-title">{p.titulo}</p>
              {p.descripcion && <p className="promo-desc">{p.descripcion}</p>}
              {p.link && (
                <a href={p.link} className="promo-link" target="_blank" rel="noopener noreferrer">
                  Ver más
                </a>
              )}
            </div>
          </div>
        ))
      )}
    </div>
  );
}
